<script>
export default {
  data() {
    return {
      scrollpx: 0,
      fixedFilter: false,
      fixedState: false,
      display: false,
    }
  },
  created() {
    window.addEventListener('scroll', this.scrolled)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrolled)
  },
  methods: {
    scrolled: function() {
      // this.scrollpx = window.scrollY
      this.scrollpx = window.scrollY
      var screenYSize = window.screen.height
      var bodyEl = document.getElementsByTagName('body')[0].clientHeight
      var footerEl = document.getElementsByTagName('footer')[0].clientHeight
      if (
        this.scrollpx >= 0 &&
        this.scrollpx <= bodyEl - (footerEl + screenYSize - 25)
      ) {
        this.fixedFilter = true
      } else {
        this.fixedFilter = false
      }
    },
  },
}
</script>

<template>
  <div>
    <div :class="[fixedFilter ? 'fixedFilter' : 'd-none']">
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
.filterButtons {
  [class='btn-group'] {
    button {
      display: inline-flex;
      align-items: center;
      padding: 0.5rem 1rem;
      color: #fff;
      background-color: var(--primary);
      border: none;
      &:first-child {
        border-right: 1px solid #fff;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      &:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }
}
.fixedFilter {
  position: fixed;
  bottom: 0;
  left: 0%;
  z-index: 1024;
  width: 100%;
  animation-name: slideInUp;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  .filterButtons {
    margin-bottom: 1rem;
    margin-left: 22.5vw;
  }
  &.showButton {
    position: relative !important;
    .filterButtons {
      margin-left: 0 !important;
    }
  }
}
.filterContent {
  display: none;
  &.show {
    display: block !important;
    width: 100%;
    padding: 1rem;
    margin-top: 1rem;
    background: #fff;
    box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.1);
    animation-name: slideInUp;
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }
  [class~='form-group'] {
    legend {
      font-size: 1.2em;
      font-weight: 600;
    }
    [class~='btn-group-toggle'] {
      display: inline;
      label {
        width: auto !important;
        margin-top: 0.5rem;
        margin-right: 0.5rem;
        &:first-child {
          margin-left: -0.5rem;
        }
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  .filterContent {
    [class~='form-group'] {
      [class~='btn-group-toggle'] {
        display: inline;
        label {
          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
</style>
